export default __webpack_public_path__ + "static/media/others2.b71d0655.jpg";